import styled from 'styled-components';
import * as COLORS from 'Constants/colors';
import { breakpoints } from 'Constants';

export default MobilePackageSearch => styled(MobilePackageSearch)`
  display: block;
  min-height: 20px;
  max-width: 1140px;
  background-color: #f7f4fa;

  .select-departure-box {
    height: auto;
  }

  .search-input_holder {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing.one};
    padding: ${({ theme }) => `${theme.spacing.two} ${theme.spacing.four} 0`};
    position: relative;

    label {
      color: ${COLORS.darkGrey};
      font-size: 10px;
      font-weight: 700;
      letter-spacing: 0;
      line-height: 1.2;
      margin: 0;
      padding-left: ${({ theme }) => theme.spacing.one};
      text-transform: none;
      white-space: normal;
    }

    .mv-input,
    .select-departure-box {
      width: 100%;
    }

    .mv-input-container,
    .mv-input-holder {
      width: 100%;
    }

    .mv-input-container {
      border-radius: 999px;
      box-shadow: 0 2px 10px rgba(49, 23, 75, 0.08);
      overflow: hidden;
    }

    input {
      min-height: 40px;
      font-size: 13px;
    }

    button {
      border-radius: 999px;
      box-shadow: 0 2px 10px rgba(49, 23, 75, 0.08);
      min-height: 36px;
      padding-left: ${({ theme }) => theme.spacing.three};
      padding-right: ${({ theme }) => theme.spacing.three};
      font-size: 11px;
    }
  }

  .package-search_top-card + .search-input_holder {
    label {
      opacity: 0.72;
    }

    button {
      color: ${COLORS.darkGrey};
      opacity: 0.86;
    }
  }

  .package-search_top-card + .search-input_holder + .search-input_holder {
    label {
      color: ${COLORS.newBackground};
      font-size: 11px;
      opacity: 0.85;
    }

    input {
      min-height: 38px;
    }
  }

  .package-search_top-card {
    background-color: #f7f4fa;
    box-shadow: none;
    overflow: hidden;
    padding: ${({ theme }) => `${theme.spacing.two} ${theme.spacing.four}`};

    .package-search-tabs_holder {
      display: flex;
      background: ${COLORS.white};
      border-radius: 999px;
      box-shadow: 0 2px 12px rgba(49, 23, 75, 0.1);
      gap: 4px;
      padding: 4px;

      .package-search-tabs_item {
        transition: 0.2s;
        cursor: pointer;
        border-radius: 999px;
        height: 36px;
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;

        span {
          font-size: 13px;
          line-height: 1;
        }

        &.active {
          background-color: ${COLORS.important};
          box-shadow: 0 4px 12px rgba(255, 103, 0, 0.22);
        }
      }
    }

    .package-search-options_holder {
      min-height: 154px;
      box-shadow: none;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      padding: 14px 0 2px;

      .icons-list_holder {
        position: relative;
        overflow-x: auto;
        overflow-y: hidden;
        padding: 0;
        margin-bottom: ${({ theme }) => theme.spacing.two};

        &.scrollable::after {
          background: linear-gradient(
            90deg,
            rgba(247, 244, 250, 0),
            #f7f4fa 82%
          );
          bottom: 0;
          content: '';
          pointer-events: none;
          position: absolute;
          right: 0;
          top: 0;
          width: 24px;
        }

        &:last-child {
          margin-bottom: 0;
        }

        ::-webkit-scrollbar {
          display: none;
        }
      }

      .icons-list {
        display: flex;
        align-items: flex-start;
        gap: ${({ theme }) => theme.spacing.two};

        &.wrap {
          flex-wrap: wrap;
        }
      }

      .icons-list_holder.scrollable {
        scroll-padding-left: 0;
        scroll-snap-type: x proximity;

        .package-search-icon {
          min-width: 96px;
          scroll-snap-align: start;
          width: 96px;

          .package-search-icon_title {
            width: 96px;
          }
        }
      }

      .months-list_holder.scrollable {
        .icons-list {
          gap: 6px;
          padding-right: 42px;
        }

        .package-search-icon.small {
          min-width: 60px;
          width: 60px;
        }
      }

      .package-search-icon {
        width: 86px;

        .package-search-icon_title {
          color: ${COLORS.newBackground};
          font-size: 12px;
          min-height: 30px;
          line-height: 15px;
          margin: 6px auto 0;
          width: 86px;
        }

        .package-search-icon_container.regular {
          background: ${COLORS.white};
          border: 1px solid rgba(49, 23, 75, 0.12);
          box-shadow: 0 2px 10px rgba(49, 23, 75, 0.08);
          height: 58px;
          margin-bottom: 0;
          margin-top: 0;
          width: 58px;
        }

        .package-search-icon_container.regular.default {
          .package-search-icon_icon {
            color: ${COLORS.newBackground};
          }
        }

        .package-search-icon_container.regular.active {
          background: ${COLORS.important};
          border-color: ${COLORS.important};
          box-shadow: 0 5px 14px rgba(255, 103, 0, 0.22);

          .package-search-icon_icon {
            color: ${COLORS.white};
          }
        }

        .package-search-icon_container.small {
          align-items: center;
          background: transparent;
          border: 0;
          border-radius: 0;
          box-shadow: none;
          display: flex;
          height: 30px;
          justify-content: center;
          margin-bottom: 0;
          width: 38px;
        }

        .package-search-icon_container.small.active {
          background: transparent;
        }

        &.small {
          height: 30px;
          width: 38px;
        }
      }
    }
  }

  .order-by_container {
    padding: ${({ theme }) => `${theme.spacing.two} ${theme.spacing.four}`};

    .order-by_holder {
      height: 36px;
      margin: 0;
      background: ${COLORS.white};
      box-shadow: 0 2px 10px rgba(49, 23, 75, 0.08);
      border-radius: 999px;
      display: flex;
      gap: 4px;
      padding: 4px;

      .order-by_button {
        border-radius: 999px;
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;

        span {
          font-size: 13px;
          line-height: 1;
        }

        &.active {
          background-color: ${COLORS.important};
          box-shadow: 0 4px 12px rgba(255, 103, 0, 0.18);
        }
      }
    }
  }

  @media screen and (max-width: 1140px) {
    display: grid;
    grid-template-columns: minmax(0, 0.8fr) minmax(0, 1.2fr);

    .package-search_top-card,
    .tags-holder,
    .order-by_container {
      grid-column: 1 / -1;
    }

    .package-search_top-card {
      .package-search-options_holder {
        max-height: 174px;

        .icons-list_holder {
          margin: 0 0 ${({ theme }) => theme.spacing.two};
          display: block;

          &:last-child {
            margin-bottom: 0;
          }

          .icons-list {
            display: flex;

            & > * {
              margin: 0;
            }

            &.wrap {
              flex-wrap: nowrap;
            }
          }
        }
      }
    }
  }

  @media screen and (max-width: ${breakpoints.medium}px) {
    margin-top: 0;
  }
`;
